/**
 * Profile scripts
 *
 * @copyright 2018 Linguistica 360
 */

import $ from 'jquery';
import iziToast from 'izitoast';
import MicroModal from 'micromodal';

import { Script, injector } from '../shared/injector.js';
import { moneyFormat } from '../shared/utils.js';

injector.injectClass(class extends Script {
    onLoad() {
        this.initCancel();
        this.initUpgrade();
        this.initChange();

        if (window._autoAction === 'cancel') {
            $('.cancel_sub').trigger('click');
        }

        if (window._autoAction === 'upgrade') {
            $('.upgrade_sub').trigger('click');
        }

        if (window._autoAction === 'change' && $('#modal_change').length) {
            MicroModal.show('modal_change');
        }

        $('#show_password_profile').on('change', () => {
            if ($('#show_password_profile').is(':checked')) {
                $('#profile_form input.password').attr('type', 'text');
            } else {
                $('#profile_form input.password').attr('type', 'password');
            }
        });
    }

    initCancel() {
        const $cancel = $('.cancel_sub');
        $cancel.on('click', (e) => {
            e.preventDefault();

            const $upgrade = $('.upgrade_sub');
            if ($upgrade.data('label') === 'Downgrade') {
                this.showCancelDowngrade($cancel, $upgrade);
            } else {
                this.showCancel($cancel);
            }

            return false;
        });
    }

    initUpgrade() {
        const $upgrade = $('.upgrade_sub');
        $upgrade.on('click', (e) => {
            e.preventDefault();

            if ($upgrade.data('label') === 'Downgrade') {
                this.showDowngrade($upgrade);
            } else {
                this.showUpgrade($upgrade);
            }

            return false;
        });
    }

    showDowngrade($a) {
        $('#modal_downgrade .ok').off('click').on('click', () => {
            MicroModal.close('modal_downgrade');
            $a.next('form').trigger('submit');
        });

        $('#modal_downgrade .price').text(moneyFormat($a.data('price')));
        $('#modal_downgrade .days').text($a.data('days'));
        $('#modal_downgrade .date').text($a.data('date'));

        MicroModal.show('modal_downgrade');
    }

    showCancelDowngrade($cancel, $downgrade) {
        $('#modal_cancel .price').text(moneyFormat($downgrade.data('price')));

        $('#modal_cancel .cancel').off('click').on('click', () => {
            MicroModal.close('modal_cancel');
            this.showCancel($cancel);
        });

        $('#modal_cancel .signup-button').off('click').on('click', () => {
            MicroModal.close('modal_cancel');
            this.showDowngrade($downgrade);
        });

        MicroModal.show('modal_cancel');
    }

    showCancel($a) {
        const transition = { transitionOut: 'fadeOut' };
        const opts = {
            timeout: 20000,
            close: false,
            overlay: true,
            toastOnce: true,
            zindex: 999,
            title: 'Cancel Subscription',
            position: 'center',
            buttons: [
                ['<button>Yes, CANCEL</button>', (instance, toast) => {
                    const gets = $a.data('urls').split(',').map((url) => {
                        return $.get(url);
                    });
                    $.when(...gets).done(() => {
                        location.reload();
                    }).fail(() => {
                        location.reload();
                    });
                    instance.hide(transition, toast, 'button');
                }],
                ['<button><b>Keep It</b></button>', (instance, toast) => {
                    instance.hide(transition, toast, 'button');
                }, true],
            ],
        };

        if ($a.data('discount')) {
            const message = `
                If you cancel now, you will lose your promotional rate of
                <strong>$${$a.data('discount')}</strong> USD/mo.
                (Standard rate is
                <strong>$${$a.data('price')}</strong>/mo.)`;

            opts.message = message;
        }

        iziToast.error(opts);
    }

    showUpgrade($a) {
        const transition = { transitionOut: 'fadeOut' };
        const opts = {
            timeout: false,
            close: false,
            overlay: true,
            toastOnce: true,
            zindex: 999,
            title: `${$a.data('label')} Subscription`,
            message: $a.data('terms'),
            position: 'center',
            buttons: [
                ['<button><b>Yes</b></button>', () => {
                    $a.next('form').trigger('submit');
                }],
                ['<button>No</button>', (instance, toast) => {
                    instance.hide(transition, toast, 'button');
                }, true],
            ],
        };

        iziToast.info(opts);
    }

    initChange() {
        $('#modal_change [name=product]').on('change', () => {
            const $selected = $('#modal_change [name=product]:checked');
            $('#modal_change [name=upgrade]').val($selected.data('id'));
            $('#modal_change [name=invoice_id]').val($selected.data('invoice-id'));
            $('#modal_change [name=invoice_item_id]').val($selected.data('item-id'));
        });
    }
}, ['profile']);
